<template>
  <el-card class="box-card">
    <div slot="header" class="clearfix" style="height:30px">
      <el-row :gutter="20" style="line-height:30px">
        <el-col :span="6">
          <p class="key-title">已录入的维度</p>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <p class="keys">
            <el-tag :key="item.ID" v-for="(item,index) in list" closable @close="handleDelete(item.ID)">
              {{item.TITLE}}
            </el-tag>
          </p>
        </el-col>
      </el-row>
    </div>
    <el-row :gutter="20" style="margin-bottom:40px">
      <el-col :span="12">
        <el-input
          class="input-new-tag"
          v-model.trim="inputValue"
          ref="saveTagInput"
          size="small"
          @keyup.enter.native="addItem"
          placeholder="录入新的功能类别"
          style="width:300px"
        >
        </el-input>
      </el-col>
      <el-col :span="4">
        <el-button
          class=""
          type="primary"
          @click="addItem"
        >添加</el-button>
      </el-col>
    </el-row>
  </el-card>
</template>

<script>
export default {
  props: {
    'activeName': {
      type: String,
      default () {
        return ''
      }
    },
    'list': {
      type: Array,
      default () {
        return []
      }
    }
  },
  data () {
    return {
      loading: false,
      inputValue: '',
      form: {},
      currentPage: {
        one: 0
      }
    }
  },
  methods: {
    // 增加tag标签
    addItem () {
      if (this.inputValue === '') return
      if (this.activeName === '0') {
        this.$emit('addIndustry', this.inputValue)
      } else {
        this.$emit('addDomain', this.inputValue)
      }
    },
    // 删除tag标签
    handleDelete (id) {
      this.$emit('delete', id)
      if (this.activeName === '0') {
        this.$emit('delIndustry', id)
      } else {
        this.$emit('delDomain', id)
      }
    }
  }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// widgetTag.vue?5041fc54